export const CREATE_SHARE_DOMAIN = 'CREATE_SHARE_DOMAIN'
export const RESET_SHARES_ACTION = 'RESET_SHARES_ACTION'
export const GET_FORCE_SSL = 'GET_FORCE_SSL'

// Mutations
export const SAVE_SHARE_DOMAIN = 'SAVE_SHARE_DOMAIN'
export const RESET_SHARES = 'RESET_SHARES'
export const SAVE_FORCE_SSL = 'SAVE_FORCE_SSL'



// WEBPACK FOOTER //
// ./src/store/actions/share.js